import React, { Component } from 'react';
import AnyModel from "../../models/anymodel";
import  PanelLayout  from "../layout/panel-layout";
import { Link } from 'react-router-dom';
import Select from 'react-select';
import SimpleReactValidator from 'simple-react-validator';

import BDateInput from '../../helpers/bdate-input'


import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import moment from 'moment-jalaali';

class ExcelReport extends React.Component {
    
    
    constructor(props) {
        super(props);
        this.state = { 
           model:new AnyModel(this.refs),
           
        };
      
        this.handleTextChange = this.handleTextChange.bind(this);
        this.getData = this.getData.bind(this);
        this.handleClick= this.handleClick.bind(this);
        this.refreshModel = this.refreshModel.bind(this);


        


        SimpleReactValidator.addLocale('fa', {
            required: 'الزامی',
            integer: 'الزامی'
            
          });

        this.validator = new SimpleReactValidator({
            locale: 'fa'
          
          });

    }

     
   

    
    handleTextChange(value) {
  
        const {model}=this.state;
       
        this.setState({
            model:model
        })

        this.refreshModel();
    }

   
    componentWillReceiveProps(newProps)
    {
       
        
    }

    refreshModel () {
        let model = new AnyModel(this.refs);  
        this.setState({

            model:model

        });

        console.log('MODEL',model);

        
    }
    getData() {
        let model = new AnyModel(this.refs);
        return model;
    }
   
    handleClick = (e) => {
        if (this.validator.allValid()) {
            
            this.props.submitHandler(e);

        } else {
            this.validator.showMessages();
           
            this.forceUpdate();
        }
    };

    render() { 
        //const {model} = this.props;
        const {recieverList,model}= this.state;
        const {loading,error} = this.props;
    

 
        return ( 

        <PanelLayout title={"گزارش گیری"}>

           
            <div className="panel-body custom">

          
                
            <div class="panel panel-default">
                <div class="panel-heading">گزارش گیری</div>
                <div class="panel-body">

                    <form autoComplete="off" ref={c => { this.form = c }}>


                        <div className="row">
                            <div className="col-md-12">
                               
                            <div className="form-group">
                                <label>
                                    از تاریخ
                                </label>
                                <BDateInput
                                
                                    className="form-control"
                                    ref="fromDate" 
                                    value={moment(model.fromDate).isValid()?  model.fromDate:moment() } 
                                    onChange={this.refreshModel}
                                
                                />
                            </div>
                            <div className="form-group">
                                <label>
                                   تا تاریخ
                                </label>
                                <BDateInput
                                
                                    className="form-control"
                                    ref="toDate" 
                                    value={moment(model.toDate).isValid()?  model.toDate:moment() } 
                                    onChange={this.refreshModel}
                                
                                />
                            </div>
                                

                            </div>
                        </div>
                       
                        
                        
                       
                    </form>
                
                
                </div>
            </div>
               

            <div className="panel panel-default">
               
               <div className="toolbox">

                   <button type="button" disabled ={loading } className="btn btn-default btn-sm" onClick={this.handleClick} ><i className="fa fa-save"></i>   ذخیره گزارش
                   
                    { loading &&
                        <i className="fa fa-spinner fa-spin"></i>
                    }

                    </button>


               
               </div>
           </div>

            </div>
        </PanelLayout>





        );
    }
}

 
export default ExcelReport;